const THICKNESS_VALUES = [
    '.02', '.04', '1/32', '1/16', '1/8', '3/16', '1/4', '3/8', '1/2', '3/4', 'Other',
]
const MATERIAL_VALUES = [
    'Gemini', 'Non Glare', 'P95', 'White Acrylic', 'White Calsak',
    'Black Acrylic', 'Black Calsak', 'Clear', 'Thermoformed', 'Painted Acrylic',
    'DA Clear', 'DA White', 'Aluminum',
    'Mylar', 'Lexan', 'Cardstock',
    'Rowmark', 'Polycarbonate', 'Sintra', 'Other',
]

module.exports = {THICKNESS_VALUES, MATERIAL_VALUES}
